import { IForm } from 'core-components/classes/models/IForm'

export const getValue = <P = IForm>(item: P, keyField: string): string => {
  return item['get'] ? item['get'](keyField) : item[keyField]
}
